<mat-progress-bar mode="indeterminate" *ngIf="waiting" color="primary"></mat-progress-bar>
